import React from "react";
import "./Portfolio.scss";
import { useNavigate } from "react-router-dom";
import { PORTFOLIO_CATEGORIES, CATEGORY_META } from "./Constant";
import { useScrollReveal } from "../../../motion/useScrollReveal";
import { preloadImages } from "../../../preload/imageCache";
import { getPortfolioCategoryImages } from "../../../preload/pageAssets";

const Portfolio: React.FC = () => {
  const navigate = useNavigate();
  // Title rises + fades in first, then the subtitle, then each card reveals
  // as one coordinated motion — fade + rise + a subtle scale-up — staggered
  // across the grid.
  const revealRef = useScrollReveal<HTMLDivElement>({
    selector: ".portfolio__title, .portfolio__subtitle, .portfolio-service-card",
    stagger: 0.1,
    scale: 0.96,
  });

  return (
    <section id="art-portfolio" className="portfolio" aria-label="Game art portfolio">
      <div className="portfolio__inner" ref={revealRef}>
        <header className="portfolio__head">
          <h2 className="portfolio__title">
           Game Art Portfolio
          </h2>
          <p className="portfolio__subtitle">
           A selection of work from our studios slot games, characters, environments, and supporting elements.
          </p>
        </header>

        <div className="portfolio__cards">
          {PORTFOLIO_CATEGORIES.map((cat) => {
            const meta = CATEGORY_META[cat.id];
            const prefetch = () => preloadImages(getPortfolioCategoryImages(cat.id));
            return (
              <div
                key={cat.id}
                className="portfolio-service-card"
                onMouseEnter={prefetch}
                onFocus={prefetch}
                onTouchStart={prefetch}
              >
                <div className="portfolio-service-card__img-wrap">
                  <img
                    src={meta.image}
                    alt={cat.label}
                    className="portfolio-service-card__img"
                    loading="lazy"
                  />
                </div>
                <div className="portfolio-service-card__body">
                  <h3 className="portfolio-service-card__title">{cat.label}</h3>
                  <p className="portfolio-service-card__desc">{meta.description}</p>
                  <button
                    type="button"
                    className="portfolio-service-card__btn"
                    onClick={() => navigate(`/portfolio/${cat.id}`)}
                  >
                    View Portfolio &gt;
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
